<div class="modal-card">
  <div class="modal-card-body">
    <div class="modal-status-icon" *ngIf="_title">
      <span class="material-symbols-outlined">mark_chat_unread</span>
    </div>

    <h2 *ngIf="_title" class="modal-title">{{ _title | translate }}</h2>
    <p *ngIf="_description" class="modal-description">{{ _description | translate }}</p>

    <div *ngIf="_buttons && _buttons.length > 0" class="modal-actions-group">
      <button
        *ngFor="let button of _buttons"
        type="button"
        class="modal-btn fill--{{ button.fill || 'solid' }} color--{{ button.color || 'primary' }}"
        (click)="dismiss({}, button.action)"
      >
        <span *ngIf="button?.prefix" class="material-symbols-outlined btn-prefix">{{ button.prefix }}</span>
        <span class="btn-text">{{ (button?.label || '') | translate }}</span>
        <span *ngIf="button?.suffix" class="material-symbols-outlined btn-suffix">{{ button.suffix }}</span>
      </button>
    </div>
  </div>
</div>